import { Grid } from '@material-ui/core'
import { useQueryClient } from 'react-query'

import { useGetChatSettingsQuery } from 'api/queries/chatSettings/chatSettings'
import { GET_CHAT_SETTINGS_QUERY_KEY } from 'api/queries/chatSettings/keys'
import { useUpdateChatSettingsMutation } from 'api/mutations/chatSettings/chatSettings'
import { AiChatSettingsForm } from 'components/forms/AiChatSettingsForm/AiChatSettingsForm'
import { RouteContainer } from 'components/layout/RouteContainer/RouteContainer'

const AiSettingsScreen: React.FC = () => {
  const queryClient = useQueryClient()

  const { data, isLoading, isError } = useGetChatSettingsQuery()

  const {
    mutate,
    isLoading: isLoadingUpdate,
    isSuccess: isSuccessUpdate,
  } = useUpdateChatSettingsMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(GET_CHAT_SETTINGS_QUERY_KEY)
    },
  })

  return (
    <RouteContainer>
      <Grid container xs={12}>
        <Grid item xs={12} md={6}>
          <AiChatSettingsForm
            settings={data?.data}
            onSubmit={mutate}
            isLoadingData={isLoading}
            isError={isError}
            isLoadingUpdate={isLoadingUpdate}
            isSuccessUpdate={isSuccessUpdate}
          />
        </Grid>
      </Grid>
    </RouteContainer>
  )
}

export { AiSettingsScreen }
